import * as React from "react";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router";
import {
  AccordionDetails,
  Typography,
  Button,
  AccordionSummary,
  List,
  ListItemButton,
  Accordion,
  Divider,
} from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { motion, AnimatePresence } from "motion/react";
import { styled } from "@mui/material/styles";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import PropTypes from "prop-types";
import Drawer, { drawerClasses } from "@mui/material/Drawer";

const navItems = [
  "Home",
  "About",
  "Women",
  "Men",
  "Jewellery",
  "Contact",
  "FAQ",
];

function SidebarDrawer({ open, toggleDrawer, data }) {
  const [expanded, setExpanded] = useState(false);
  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };
  const navigation = useNavigate();

  const handleMenu = (item) => {
    let path = "/";
    if (item === "Home") {
      path = "/";
    } else if (item === "Women") {
      path = "/product_list/2";
    } else if (item === "Men") {
      path = "/product_list/1";
    } else if (item === "Jewellery") {
      path = "/product_list/3";
    } else if (item === "About") {
      path = "/about";
    } else if (item === "Contact") {
      path = "/contact";
    } else if (item === "FAQ") {
      path = "/faq";
    }

    toggleDrawer(false);
    navigation(path);
  };

  return (
    <Drawer
      open={open}
      onClose={() => toggleDrawer(false)}
      sx={{ width: "100%" }}
      role="presentation"
    >
      <div className="sidebar-container">
        <div className="sidebar-header">
          <div>
            <h3>Soyara</h3>
          </div>
          <Button variant="text" onClick={() => toggleDrawer(false)}>
            <FontAwesomeIcon icon={faXmark} />
          </Button>
        </div>
        <div className="sidebar-body">
          <List component="nav">
            {navItems.map((item, index) => {
              if (data[item]) {
                return (
                  <div key={`accordion-${index}`}>
                    <Accordion
                      className="accordion-container"
                      expanded={expanded === `panel${index}`}
                      onChange={handleChange(`panel${index}`)}
                    >
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls={`panel${index}bh-content`}
                        id={`panel${index}bh-header`}
                      >
                        <Typography component="span">{item}</Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        {Object.entries(data[item]).map(
                          ([mainCategory, subcategories]) => (
                            <div key={`mainCategory-${mainCategory}`}>
                              <h4 className="main-category-title">
                                {mainCategory}
                              </h4>
                              <List>
                                {Object.entries(subcategories).map(
                                  ([key, value]) => (
                                    <ListItemButton
                                      className="sidebar-subcategory-item"
                                      key={`subcategory-${key}`}
                                    >
                                      {value}
                                    </ListItemButton>
                                  )
                                )}
                              </List>
                            </div>
                          )
                        )}
                      </AccordionDetails>
                    </Accordion>
                    <Divider />
                  </div>
                );
              } else {
                return (
                  <div key={`list-item-${index}`}>
                    <ListItemButton onClick={() => handleMenu(item)}>
                      {item}
                    </ListItemButton>
                    <Divider />
                  </div>
                );
              }
            })}
          </List>
        </div>
      </div>
    </Drawer>
  );
}
SidebarDrawer.propTypes = {
  open: PropTypes.bool,
  toggleDrawer: PropTypes.func.isRequired,
};
export default SidebarDrawer;
